// Module
var code = `<div class="col-lg-12" style="text-align: center">
    <h4>Количество игроков с пингами: {{ vm.total_install_count }}</h4>
    (инсталлы на этих графиках ~ кол-во уникальных игроков, отправивших хотя бы один пинг 0-20 за указанный период времени)
</div>
<div class="col-lg-12">
    <bfg-chart name="retention.ShortRetentionBySecondsChart"></bfg-chart>
</div>
<div class="col-lg-12">
    <bfg-chart name="retention.ShortRetentionByMinutesChart"></bfg-chart>
</div>
`;
// Exports
module.exports = code;